import CLIM from 'clim-js-sdk'
export default {
  loginIM,
  logout,
  loginYunXinChatRoom,
  sendApplyLink,
  sendSureLink,
  sendRefuseLink,
  sendCannotLink,
  sendTextMsg,
  onSendP2PMsg,
  studentOneKeyLinkMic,
  updateYunxinMyCustom
}

// var memberMsgListener
// function setMemberMsgListener (cb) {
//   memberMsgListener = cb
// }

// var imStatusListener
// function setImStatusListener (cb) {
//   imStatusListener = cb
// }

// var normalCallBack // 普通消息回调，在互动页面显示的消息为普通消息
// function setMsgListener (cb) {
//   normalCallBack = cb
// }
let currIMType = 0
let loginInfo = {}
let handleim = null
let heartim = null
let currentGroupId = ''
// 配置IM
function loginIM (data, imType, callBackObj) {
  loginInfo = data
  currIMType = imType
  currentGroupId = data.room_id
  console.log('loginIM', data, imType, callBackObj)
  handleim = CLIM.getInstance(imType)
  handleim.on(CLIM.EVENT.MESSAGE_RECEIVED, (convType, data) => {
    // eslint-disable-next-line eqeqeq
    if (currIMType == 1) {
      handleMessage(data, (type, msg) => {
        if (type === 'c2c') {
          callBackObj && callBackObj.setMemberMsgListener(msg)
        } else {
          callBackObj && callBackObj.setMsgListener(msg)
        }
      })
    // eslint-disable-next-line eqeqeq
    } else if (currIMType == 2) {
      if (convType === CLIM.TYPES.CONV_GROUP) { // 群消息
        for (let index = 0; index < data.length; index++) {
          const element = data[index]
          if (element.type === 'text' && element.text) {
            callBackObj && callBackObj.setMsgListener(JSON.parse(element.text), element)
          } else if (element.type === 'notification') {
            if (element.attach.type === 'updateChatroom') {
              console.log('updateChatroom', element)
              handleim.getChatroom().then(res => {
                console.log('updateChatroom===', res)
                callBackObj && callBackObj.setMsgListener({
                  module: 'system_message_group_introduction',
                  online_num: JSON.parse(res.chatroom.custom).online_num
                })
              })
            }
          }
        }
      } else if (convType === CLIM.TYPES.CONV_C2C) {
        if (data && data.type === 'text') {
          callBackObj && callBackObj.setMemberMsgListener(JSON.parse(data.text))
        }
      }
    }
  })

  handleim.on(CLIM.EVENT.SDK_READY, (convType, obj) => {

  })

  handleim.on(CLIM.EVENT.NET_STATE_CHANGE, (convType, event) => {
    // eslint-disable-next-line eqeqeq
    if (currIMType == 1) {
      handleStatus(event, (msg) => {
        callBackObj && callBackObj.setImStatusListener(msg)
      })
    // eslint-disable-next-line eqeqeq
    } else if (currIMType == 2) {

    }
  })

  handleim.on(CLIM.EVENT.KICKED_OUT, (convType, obj) => {
    // eslint-disable-next-line eqeqeq
    if (currIMType == 2) {
      if (convType === CLIM.TYPES.CONV_GROUP) {
        callBackObj && callBackObj.setImStatusListener({ 'error': 'kicked' })
      }
    }
  })

  handleim.on(CLIM.EVENT.DISCONNECT, (convType, obj) => {
    // eslint-disable-next-line eqeqeq
    if (currIMType == 2) {
      if (convType === CLIM.TYPES.CONV_GROUP) {
        callBackObj && callBackObj.setImStatusListener({ 'error': 'noconnect' })
      }
    }
  })

  handleim.on(CLIM.EVENT.ERROR, (convType, error) => {
    console.log('ERROR=====')
    if (currIMType === 2) {
      if (convType === CLIM.TYPES.CONV_GROUP || convType === CLIM.TYPES.CONV_C2C) {
        callBackObj && callBackObj.setImStatusListener({ 'error': 'imerror', 'msg': error })
      }
    }
  })

  handleim.on(CLIM.EVENT.CONNECT, (convType, error) => {
    console.log('CONNECT==链接成功===')
    if (currIMType === 2) {
      if (convType === CLIM.TYPES.CONV_GROUP || convType === CLIM.TYPES.CONV_C2C) {
        callBackObj && callBackObj.setImStatusListener({ 'status': 'connect' })
      }
    }
  })

  handleim.on(CLIM.EVENT.RECONNECT, (convType, error) => {
    console.log('RECONNECT===')
    if (currIMType === 2) {
      if (convType === CLIM.TYPES.CONV_GROUP || convType === CLIM.TYPES.CONV_C2C) {
        callBackObj && callBackObj.setImStatusListener({ 'error': 'noconnect' })
      }
    }
  })

  console.log('options====')
  let options = {}
  // eslint-disable-next-line eqeqeq
  if (imType == 1) {
    options = {
      sdk_appid: data.app_id,
      userID: `${data.fans_id}`,
      userSig: data.tsl_sig
    }
  // eslint-disable-next-line eqeqeq
  } else if (imType == 2) {
    options = {
      debug: false,
      appKey: data.appKey,
      account: data.fans_id + '',
      token: data.yxToken,
      authType: 1,
      db: false
    }
  }
  console.log('options====', options)
  handleim.login(options).then(res => {
    // eslint-disable-next-line eqeqeq
    if (imType == 1) {
      handleim.joinGroup({ groupID: data.room_id, type: CLIM.TYPES.GRP_AVCHATROOM }).then(imResponse => {
        switch (imResponse.data.status) {
          case CLIM.TYPES.JOIN_STATUS_SUCCESS: // 加群成功
            console.log(imResponse.data.group) // 加入的群组资料
            if (imResponse.data.group.introduction) {
              callBackObj && callBackObj.setMsgListener({
                module: 'system_message_group_introduction',
                online_num: JSON.parse(imResponse.data.group.introduction).online_num
              })
            }
            if (imResponse.data.group.notification) {
              callBackObj && callBackObj.setMsgListener({
                module: 'system_message_group_notification',
                content: JSON.parse(imResponse.data.group.notification)
              })
            }
            break
          case CLIM.TYPES.JOIN_STATUS_ALREADY_IN_GROUP: // 已经在群中
            console.log(imResponse.data.group) // 加入的群组资料
            if (imResponse.data.group.introduction) {
              callBackObj && callBackObj.setMsgListener({
                module: 'system_message_group_introduction',
                online_num: JSON.parse(imResponse.data.group.introduction).online_num
              })
            }
            if (imResponse.data.group.notification) {
              callBackObj && callBackObj.setMsgListener({
                module: 'system_message_group_notification',
                content: JSON.parse(imResponse.data.group.notification)
              })
            }
            break
          default: {
            break
          }
        }
      }).catch(err => {
        console.log('err====>', err)
      })
    // eslint-disable-next-line eqeqeq
    } else if (imType == 2) {
      handleim.getChatroomAddress({ chatroomId: data.chatroomId }).then(address => {
        handleim.joinGroup({
          appKey: data.appKey,
          account: data.fans_id,
          token: data.yxToken,
          loginAuthType: 1,
          chatroomId: data.chatroomId,
          chatroomAddresses: address,
          tags: data.tags,
          chatroomEnterCustom: `{"header":"${data.header}"}`,
          notifyTargetTags: '{"tag": ".*", "matchType": "regex"}',
          chatroomNick: data.nick,
          chatroomAvatar: data.header,
          chatroomCustom: JSON.stringify(data.custom)
        }).then(() => {
          handleim.getChatroom().then(res => {
            if (res.chatroom.custom) {
              callBackObj && callBackObj.setMsgListener({
                module: 'system_message_group_introduction',
                online_num: JSON.parse(res.chatroom.custom).online_num
              })
            }
          })
        }).catch(err => {
          console.log('err====>', err)
        })
      }).catch(err => {
        console.log('err====>', err)
      })
    }
  })
}
function loginYunXinChatRoom (data, callBackObj) {
  heartim = new CLIM(2)
  heartim.on(CLIM.EVENT.KICKED_OUT, (convType, obj) => {
    if (convType === CLIM.TYPES.CONV_GROUP) {
      callBackObj && callBackObj.setImStatusListener({ 'error': 'kicked' })
    }
  })

  heartim.on(CLIM.EVENT.DISCONNECT, (convType, obj) => {
    if (convType === CLIM.TYPES.CONV_GROUP) {
      callBackObj && callBackObj.setImStatusListener({ 'error': 'noconnect' })
    }
  })

  heartim.joinGroup({
    appKey: data.appKey,
    account: data.fans_id,
    token: data.yxToken,
    loginAuthType: 1,
    chatroomId: data.chatroomId,
    chatroomAddresses: data.address,
    tags: data.tags,
    chatroomEnterCustom: `{"header":"${data.header}"}`,
    notifyTargetTags: '{"tag": ".*", "matchType": "regex"}',
    chatroomCustom: JSON.stringify(data.custom)
  })
}

// 申请连麦
function sendApplyLink () {
  var date1 = new Date()
  var timestamp = Date.parse(date1)
  var time = date1.pattern('MM-dd hh:mm')
  var obj = {}
  obj.nick = loginInfo.nick
  obj.header_url = loginInfo.header
  obj.fans_id = loginInfo.fans_id
  obj.time = time
  obj.msgid = timestamp
  obj.module = 'applyLink'

  // var text = JSON.stringify(obj)
  onSendMsg(obj)
}

// 接收老师邀请，确认上麦
function sendSureLink () {
  var date1 = new Date()
  var timestamp = Date.parse(date1)
  var time = date1.pattern('MM-dd hh:mm')
  var obj = {}
  obj.nick = loginInfo.nick
  obj.header_url = loginInfo.header
  obj.fans_id = loginInfo.fans_id
  obj.time = time
  obj.msgid = timestamp
  obj.module = 'sureLink'
  // var text = JSON.stringify(obj)
  onSendMsg(obj)
}

// 学生一键连麦
function studentOneKeyLinkMic () {
  var date1 = new Date()
  var timestamp = Date.parse(date1)
  var time = date1.pattern('MM-dd hh:mm')
  var obj = {}
  obj.nick = loginInfo.nick
  obj.header_url = loginInfo.header
  obj.fans_id = loginInfo.fans_id
  obj.time = time
  obj.msgid = timestamp
  obj.student_onekey_linkMic = 1
  obj.module = 'applyLink'
  // var text = JSON.stringify(obj)
  onSendMsg(obj)
}

// 接收老师邀请，拒绝上麦
function sendRefuseLink () {
  var date1 = new Date()
  var timestamp = Date.parse(date1)
  var time = date1.pattern('MM-dd hh:mm')
  var obj = {}
  obj.nick = loginInfo.nick
  obj.header_url = loginInfo.header
  obj.fans_id = loginInfo.fans_id
  obj.time = time
  obj.msgid = timestamp
  obj.module = 'refuseLink'
  // var text = JSON.stringify(obj)
  onSendMsg(obj)
}

function sendTextMsg (msg) {
  // var text = JSON.stringify(msg)
  onSendMsg(msg)
}

// 当前设备不支持连麦
function sendCannotLink (content) {
  var date1 = new Date()
  var timestamp = Date.parse(date1)
  var time = date1.pattern('MM-dd hh:mm')
  var obj = {}
  obj.nick = loginInfo.nick
  obj.header_url = loginInfo.header
  obj.fans_id = loginInfo.fans_id
  obj.time = time
  obj.msgid = timestamp
  obj.module = 'cannotLink'
  obj.content = content
  // var text = JSON.stringify(obj)
  onSendMsg(obj)
}
// eslint-disable-next-line no-extend-native
Date.prototype.pattern = function (fmt) {
  var o = {
    'M+': this.getMonth() + 1, // 月份
    'd+': this.getDate(), // 日
    'h+': this.getHours() % 12 === 0 ? 12 : this.getHours() % 12, // 小时
    'H+': this.getHours(), // 小时
    'm+': this.getMinutes(), // 分
    's+': this.getSeconds(), // 秒
    'q+': Math.floor((this.getMonth() + 3) / 3), // 季度
    S: this.getMilliseconds() // 毫秒
  }
  var week = {
    '0': '/u65e5',
    '1': '/u4e00',
    '2': '/u4e8c',
    '3': '/u4e09',
    '4': '/u56db',
    '5': '/u4e94',
    '6': '/u516d'
  }
  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(
      RegExp.$1,
      (this.getFullYear() + '').substr(4 - RegExp.$1.length)
    )
  }
  if (/(E+)/.test(fmt)) {
    fmt = fmt.replace(
      RegExp.$1,
      (RegExp.$1.length > 1
        ? RegExp.$1.length > 2
          ? '/u661f/u671f'
          : '/u5468'
        : '') + week[this.getDay() + '']
    )
  }
  for (var k in o) {
    if (new RegExp('(' + k + ')').test(fmt)) {
      fmt = fmt.replace(
        RegExp.$1,
        RegExp.$1.length === 1 ? o[k] : ('00' + o[k]).substr(('' + o[k]).length)
      )
    }
  }
  return fmt
}

// 发送IM消息
function onSendMsg (text) {
  let options = {}
  if (currIMType === 2) {
    options = {
      text: JSON.stringify(text),
      convType: CLIM.TYPES.CONV_GROUP, // 发送群聊消息
      msgType: CLIM.TYPES.MSG_TEXT
    }
  } else if (currIMType === 1) {
    options = {
      to: currentGroupId + '',
      convType: CLIM.TYPES.CONV_GROUP, // 发送群聊消息
      msgType: CLIM.TYPES.MSG_TEXT,
      payload: {
        text: JSON.stringify(text)
      }
    }
  }
  handleim.sendMessage(options).then(res => {
  })
}

function onSendP2PMsg (text, fansId) {
  let options = {}
  if (currIMType === 2) {
    options = {
      to: `${fansId}`,
      text: JSON.stringify(text),
      convType: CLIM.TYPES.CONV_C2C, // 发送群聊消息
      msgType: CLIM.TYPES.MSG_TEXT
    }
  } else if (currIMType === 1) {
    options = {
      to: fansId + '',
      convType: CLIM.TYPES.CONV_C2C, // 发送群聊消息
      msgType: CLIM.TYPES.MSG_TEXT,
      payload: {
        text: JSON.stringify(text)
      }
    }
  }
  handleim.sendMessage(options).then(res => {
  })
}

// 登出
function logout (callBack) {
  if (handleim) {
    handleim.logout().then(res => {
    })
  }
  if (heartim) {
    heartim.logout().then(res => {
    })
  }
}

function updateYunxinMyCustom (params) {
  if (handleim) {
    handleim.updateMyChatroomMemberInfo({
      member: {
        custom: JSON.stringify(params)
      },
      needNotify: false
    }).then(res => {
      console.log('更新自己在聊天室内的信息')
    })
  }

  if (heartim) {
    heartim.updateMyChatroomMemberInfo({
      member: {
        custom: JSON.stringify(params)
      },
      needNotify: false
    }).then(res => {
      console.log('更新自己在聊天室内的信息')
    })
  }
}

function handleMessage (event, callBack) {
  for (let index = 0; index < event.length; index++) {
    const element = event[index]
    let text = element.payload.text
    let msgData = null
    if (text) {
      text = text.replace(/&quot;/g, '"')
      msgData = JSON.parse(text)
    }
    if (element.conversationType === CLIM.TYPES.CONV_C2C) { // 1V1消息
      if (msgData) {
        callBack('c2c', msgData)
      }
    } else if (element.conversationType === CLIM.TYPES.CONV_GROUP && currentGroupId === element.to) { // 群消息
      if (element.type === 'TIMGroupTipElem') { // 群信息修改提示
        let groupProfile = element.payload.newGroupProfile
        if (groupProfile) {
          if (groupProfile.introduction) {
            callBack('group', {
              module: 'system_message_group_introduction',
              online_num: JSON.parse(groupProfile.introduction).online_num
            })
          }
          if (groupProfile.notification) {
            callBack('group', {
              module: 'system_message_group_notification',
              content: JSON.parse(groupProfile.notification)
            })
          }
        }
      } else if (element.type === CLIM.TYPES.MSG_CUSTOM) {
        if (element.payload.extension === 'TXWhiteBoardExt') {
          callBack('group', {
            module: 'TXWhiteBoardExt',
            content: element.payload.data
          })
        }
      } else { // 群消息提示
        if (msgData) {
          callBack('group', msgData)
        }
      }
    }
  }
}

function handleStatus (event, callBack) {
  if (event.data.state === CLIM.TYPES.NET_STATE_CONNECTED) {
    callBack({ ErrorCode: 1 })
  } else if (event.data.state === CLIM.TYPES.NET_STATE_CONNECTING) {
    // imStatusListener({ErrorCode: 1})
  } else if (event.data.state === CLIM.TYPES.NET_STATE_DISCONNECTED) {
    callBack({ ErrorCode: 9999 })
  }
}



// WEBPACK FOOTER //
// ./src/kits/im/handleim.js